export enum SpreadFilterEnum {
  All = "all",
  One = "one",
  Three = "three",
  Seven = "seven",
  Ten = "ten",
  Custom = "custom",
}
